import { useEffect, useState } from "react";
import Topheader from "../../component/Topheader";
import axios from "axios";
import API_URL from "../../config";

const AddTemplate = () => {
  const [formData, setFormData] = useState({
    file: null,
    template_name: "",
    template_description: "",
    category_id: "",
    category_name: "", 
  });
  const [category, setCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [error, setError] = useState(""); // Error state for general feedback

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setIsLoading(true); // Set loading to true while fetching
      const response = await axios.get(
        `${API_URL}/api/categories/get-category`
      );
      setCategory(response.data.data);
      setIsLoading(false); // Set loading to false after fetching
    } catch (error) {
      console.error("Error fetching categories", error);
      setIsLoading(false); // Stop loading if there's an error
      setError("Failed to load categories. Please try again later.");
    }
  };

  const handleCategoryChange = (e) => {

    const categoryName = e.target.options[e.target.selectedIndex].text; // Get the selected category name
  // console.log("Selected Category Name:", categoryName); // Log the selected category name

    const selectedCategoryId = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      category_id: selectedCategoryId,
      category_name: categoryName, // Store the selected category name 
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // File size check (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert("File size too large. Maximum size is 5MB");
      return;
    }

    // Allowed file types: .docx, .pdf
   const allowedTypes = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/pdf", // .pdf
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "image/jpeg", // optional - for images
  "image/png",  // optional
  "text/plain", // .txt
  // aur bhi add kar sakte ho jaise .csv, .pptx etc.
];

    // Check if the file type is not allowed
    if (!allowedTypes.includes(file.type)) {
      alert("Only .docx and .pdf files are allowed.");
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      file: file,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all required fields are filled
    if (
      !formData.file ||
      !formData.template_name ||
      !formData.template_description ||
      !formData.category_id
    ) {
      alert("Please fill all the fields.");
      return;
    }

    try {
      setIsLoading(true); // Set loading state to true when submitting
      setError(""); // Clear any previous error

      // Create FormData object for file submission
      const submitFormData = new FormData();
      submitFormData.append("file", formData.file);
      submitFormData.append("template_name", formData.template_name);
      submitFormData.append(
        "template_description",
        formData.template_description
      );
      submitFormData.append("category_id", formData.category_id);
      submitFormData.append("category_name", formData.category_name);

      // Make the POST request to add the template
      const response = await axios.post(
        `${API_URL}/api/templates/add-template`,
        submitFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Success feedback
      alert("Template added successfully.");
      setIsLoading(false); // Stop loading when done
    } catch (error) {
      console.error("Error submitting template", error);
      setError("Error submitting the template. Please try again.");
      setIsLoading(false); // Stop loading if there's an error
    }
  };

  return (
    <>
      <div className="">
        {/* <Topheader /> */}
        <div className="">
          <div className="container-fluid">
            <div className="card bg-info-subtle shadow-none position-relative overflow-hidden mb-4">
              <div className="card-body px-4 py-3">
                <div className="row align-items-center">
                  <div className="col-9">
                    <h4 className="fw-semibold mb-8">Add Template</h4>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <a
                            className="text-muted text-decoration-none"
                            href="../dark/index.html"
                          >
                            Home
                          </a>
                        </li>
                        <li className="breadcrumb-item" aria-current="page">
                          Template
                        </li>
                        <li className="breadcrumb-item" aria-current="page">
                          Add Template
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-3">
                    <div className="text-center mb-n5">
                      <img
                        src="../../assets/assets/images/backgrounds/welcome-bg.svg"
                        alt="breadcrumb-img"
                        className="img-fluid mb-n4"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-8 justify-content-center mx-auto">
                <div className="card shadow-sm">
                  <div className="container py-5">
                    <h1 className="mb-4">Add Template</h1>
                    {error && (
                      <div className="alert alert-danger">{error}</div>
                    )}{" "}
                    {/* Show error message if exists */}
                    <form className="mb-4" onSubmit={handleSubmit}>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label htmlFor="file" className="form-label">
                            Template File
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="file"
                            name="file"
                            onChange={handleFileChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="template_name" className="form-label">
                            Template Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your template name"
                            id="template_name"
                            name="template_name"
                            value={formData.template_name}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-md-6">
                          <label
                            htmlFor="template_description"
                            className="form-label"
                          >
                            Template Description
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your template description"
                            id="template_description"
                            name="template_description"
                            value={formData.template_description}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="category" className="form-label">
                            Select Category
                          </label>
                          <select
                            className="form-select"
                            id="category"
                            name="category_id"
                            value={formData.category_id}
                            onChange={handleCategoryChange}
                          >
                            <option value="" hidden>
                              Select Template Category
                            </option>
                            {category.map((cat) => (
                              <option key={cat._id} value={cat._id}>
                                {cat.category_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={isLoading}
                        >
                          {isLoading ? "Adding Template..." : "Add Template"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTemplate;
